import { render, staticRenderFns } from "./admin-contracts-2026.vue?vue&type=template&id=4baf8a82&scoped=true"
import script from "./admin-contracts-2026.vue?vue&type=script&lang=js"
export * from "./admin-contracts-2026.vue?vue&type=script&lang=js"
import style0 from "./admin-contracts-2026.vue?vue&type=style&index=0&id=4baf8a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf8a82",
  null
  
)

export default component.exports